require('./hireNewCreditCardStep4.scss');

import React, { useState } from 'react';
import { i18n } from 'core/i18n';
import { HireNewCreditCardSummary } from '../hireNewCreditCardSummary/hireNewCreditCardSummary';
import { HireNewCreditCardPdf } from '../hireNewCreditCardPdf/hireNewCreditCardPdf';
import { OKConsents } from 'gdpr-consents/components/OKConsents/OKConsents.js';
import { GDPRSignaturePattern } from 'components/gdprSignaturePattern/gdprSignaturePattern';
import BlockInfo from 'components/contactCenter/blockInfo/blockInfo';
import PersonalDataHelper from 'utilities/personalDataHelper';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
import ContactCenterRender from 'components/conditionalRender/contactCenterRender';
import { NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES } from 'constants/flagBasedFeatures';

import {
    MULTIPLE_OPERATIONS,
    HIRE_NEW_CREDIT_CARD_PACK_AND_GDPR
} from 'constants/operationTypes';
import { CARD_PAYMENT_METHOD_UNIQUE, FOURTH_STEP } from 'constants/index';
import ContactCenterNewValidationCards from 'components/hire/contactCenterValidationCards/contactCenterNewValidationCards';


const { FormattedText, formatText } = i18n;

export const HireNewCreditCardStep4 = ({
    immHireCardNameSelector,
    immHireCreditLimit,
    immHirePaymentMethod,
    immShippingAddressList,
    placementIdCard,
    hireNewCreditCard,
    operationParams,
    immProfile,
    immPdfRevolvingPersistent,
    immAccounts,
    selectedAccount,
    immFlagBasedFeatures,
    processEmail,
    onHandleChangeCheckBoxCC,
    handleAgreementCheckboxChange,
    cardType,
}) => {
    const operationProcessId = hireNewCreditCard.get('operationProcessIdInitPolicy')
    const name = PersonalDataHelper.getFullName(immProfile, false);
    const keyName = `<b>${name}</b>`;
    const showRevolvingDocument = paymentMethodType !== CARD_PAYMENT_METHOD_UNIQUE;
    const [printOffice, setPrintOffice] = useState(false)
    const onHandleChangeCheckBox = (evt) => {
        return handleAgreementCheckboxChange(evt, FOURTH_STEP)
    }
    const buildLegalConfirmationSection = (showRevolvingDocument, amount) => {
        const productType = immHireCreditLimit.get('productType');
        const productSubType = immHireCreditLimit.get('productSubType');
        const standard = immHireCreditLimit.get('referenceStandard');
        const precontractualMailProductInfo = {
            productName: 'Vanity Fair Card',
            producto: productType,
            standard: standard,
            subproducto: productSubType,
        }

        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const immStep = hireNewCreditCard.getIn(['steps', FOURTH_STEP]);
        const agreementLabel = <FormattedText value={'hireCardNeruda-hireCardNeruda_step4NewCheckboxText'} />;
        const agreementErrorMsg = formatText('hireCardNeruda-hireCardNeruda_step4CheckboxErrorMsg');
        const documentINE = hireNewCreditCard.get('documentINE')
        const documentPolicy = hireNewCreditCard.get('documentPolicy')
        const newIntLoading = documentINE && documentPolicy
        const sendMailParams = {
            type: productType,
            subType: productSubType,
            standar: standard,
        };
        return (
            <ContactCenterNewValidationCards
                amount={amount}
                agreementErrorMsg={agreementErrorMsg}
                agreementLabel={agreementLabel}
                contractName="visa-open"
                handleAgreementCheckboxChange={onHandleChangeCheckBox}
                isContractingProcess
                immStep={immStep}
                precontractualMailProductInfo={precontractualMailProductInfo}
                sendMailParams={sendMailParams}
                showIneAndRevolving={true}
                showRevolvingDocument={showRevolvingDocument}
                processEmail={processEmail}
                immHireCardOpenCredit={hireNewCreditCard}
                onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                ineNotCall={newCardsFF}
                newIntLoading={newIntLoading}
                newCardsFF={newCardsFF}
            />
        )

    }
    const paymentMethodType = immHirePaymentMethod.get('type');
    const amount = immHireCreditLimit.get('creditLimit');
    const legalConfirmationSection = buildLegalConfirmationSection(showRevolvingDocument, amount);
    const agreeIneCheckbox = hireNewCreditCard.get('agreeIneCheckbox')
    const documentPolicy = hireNewCreditCard.get('documentPolicy')
    return (
        <article className="hire-new-credit-card">
            <FormattedText
                className='print-title hire-card-neruda-step-five__title'
                value="hireCardOpenCredit-step4Title"
            />
            {__CONTACT_CENTER__ && !isPrintOfficeMode() &&
            <div className="block-info-container">
                <BlockInfo>
                    <FormattedText className="block-info-text" value={'cc_hireNewCreditCard-confirmationAgentLabelStep4'} injectedStrings={[keyName]} />
                </BlockInfo>
            </div>
            }
            <FormattedText
                className='print-paragraph hire-card-neruda-step-five__subtitle'
                value="hireCardOpenCredit-step4Subtitle"
            />
            <HireNewCreditCardSummary
                immHireCardNameSelector={immHireCardNameSelector}
                immHireCreditLimit={immHireCreditLimit}
                immHirePaymentMethod={immHirePaymentMethod}
                immShippingAddressList={immShippingAddressList}
                immPdfRevolvingPersistent={immPdfRevolvingPersistent}
                immAccounts={immAccounts}
                selectedAccount={selectedAccount}
                cardType={cardType}
            />
            <OKConsents placementId={placementIdCard} />
            {__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                <BlockInfo>
                    <p className="requiredReading">
                        <FormattedText value="cc_hireNewCreditCard-requiredReading" />
                    </p>
                    <FormattedText value="cc_hireNewCreditCard-confirmationConsentsStep4" />
                </BlockInfo>
            }
            {!__CONTACT_CENTER__ && !isPrintOfficeMode() &&

                <HireNewCreditCardPdf
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immShippingAddressList={immShippingAddressList}
                    hireNewCreditCard={hireNewCreditCard}
                    setPrintOffice={setPrintOffice}
                />
            }
            {__CONTACT_CENTER__ && isPrintOfficeMode() &&

                <HireNewCreditCardPdf
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immShippingAddressList={immShippingAddressList}
                    hireNewCreditCard={hireNewCreditCard}
                    setPrintOffice={setPrintOffice}
                />
            }
            {__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                <ContactCenterRender>
                    {legalConfirmationSection}
                </ContactCenterRender>
            }
            {__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                <>
                    {agreeIneCheckbox &&
                        <GDPRSignaturePattern
                            operationType={MULTIPLE_OPERATIONS}
                            operationParams={operationParams}
                            multiOTPMessageCode={HIRE_NEW_CREDIT_CARD_PACK_AND_GDPR}
                            newOperationProcessId={operationProcessId}
                            isEasyLoanTypeAB={isPrintOfficeMode() && true}
                        />
                    }
                </>

            }
            {__CONTACT_CENTER__ && isPrintOfficeMode() && printOffice &&
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={operationParams}
                    multiOTPMessageCode={HIRE_NEW_CREDIT_CARD_PACK_AND_GDPR}
                    newOperationProcessId={operationProcessId}
                    isEasyLoanTypeAB={isPrintOfficeMode() && true}

                />

            }
            {!__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                <>
                    {documentPolicy &&
                
                        <GDPRSignaturePattern
                            operationType={MULTIPLE_OPERATIONS}
                            operationParams={operationParams}
                            multiOTPMessageCode={HIRE_NEW_CREDIT_CARD_PACK_AND_GDPR}
                            newOperationProcessId={operationProcessId}
                            isOverDraft
                        // isEasyLoanTypeAB={isPrintOfficeMode() && true}
                            
                        />
                    }

                </>
            }
        </article>
    );
};

